import { useParams, Navigate } from 'react-router-dom';
import { toast } from 'sonner';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { PRODUCTS, getProduct } from '@/data/products';
import ProductBreadcrumb from '@/components/product-sheet/ProductBreadcrumb';
import ProductHero from '@/components/product-sheet/ProductHero';
import ProductSpecs from '@/components/product-sheet/ProductSpecs';
import ProductHighlights from '@/components/product-sheet/ProductHighlights';
import ProductPdfPreview from '@/components/product-sheet/ProductPdfPreview';
import ProductNav from '@/components/product-sheet/ProductNav';

export default function ProductSheet() {
  const { slug } = useParams();
  const product = getProduct(slug);
  if (!product) return <Navigate to="/products" replace />;

  const idx = PRODUCTS.findIndex(p => p.slug === slug);
  const next = PRODUCTS[(idx + 1) % PRODUCTS.length];
  const prev = PRODUCTS[(idx - 1 + PRODUCTS.length) % PRODUCTS.length];

  const handleDownload = () => {
    if (product.pdf) {
      window.open(product.pdf, '_blank', 'noopener,noreferrer');
      toast.success(`${product.name} sell sheet`, { description: 'Opening the official PDF in a new tab.' });
    } else {
      toast.error('PDF not available', { description: 'Reach out at toronto@vegandanishbakery.com.' });
    }
  };

  return (
    <main className="min-h-screen bg-background">
      <Header variant="solid" />
      <ProductBreadcrumb product={product} index={idx} />
      <ProductHero product={product} onDownload={handleDownload} />
      <ProductSpecs product={product} />
      <ProductHighlights product={product} />
      <ProductPdfPreview product={product} onDownload={handleDownload} />
      <ProductNav prev={prev} next={next} />
      <Footer />
    </main>
  );
}
